import type { GetChangelogRequest, GetChangelogResponse } from "@somewear/api";
import { createActionSet } from "@somewear/model";

export const changelogActions = {
	getChangelog: createActionSet<GetChangelogRequest.AsObject, GetChangelogResponse.AsObject>(
		"changelog/get",
	),
};
